/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */
//const BASEURL = 'http://localhost:8000'
const BASEURL = 'https://www.api.megahotmop.com'
export default BASEURL
